var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 124.27",
    style: {
      enableBackground: "new 0 0 1080 124.27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.75,57.65v-0.29c9.58-3.24,18.03-9.78,18.03-24.07c0-18.03-14.3-29.23-38.02-29.23H2.94v12.97h50.7 c13.31,0,19.5,7.32,19.5,17.88c0,10.56-4.57,17.74-21.12,17.74H2.94v12.97h54.78c12.18,0,20,8.3,20,20.83 c0,10.86-4.57,20.78-23.24,20.78H2.94v13.02H53c24.02,0,39.3-12.33,39.3-33.8C92.3,69.05,81.93,59.77,69.75,57.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.5,4.03v103.2h60.94v13h-75.57V4.03H117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.13,4.05h-16.26l-42.89,116.19h15.13l9.78-27.76l0.44-1.33h0.05l5.6-15.28l0.15-0.44l19.75-57.92h0.29 l19.7,57.92h0.05l5.6,15.72l0.49,1.33l9.78,27.76h15.08L248.13,4.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.41,4.03h17.88l58.02,95.73h0.33V4.03h14.63v116.2h-17.88l-58.02-95.4h-0.32v95.4h-14.63V4.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.36,4.03v62.25L478.7,4.03h17.88L450.91,52.3l48.92,67.93h-17.07l-41.61-57.86l-20.8,21.94v35.92h-14.63 V4.03H420.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M623.04,89.85c0,16.9-12.51,32.67-41.93,32.67c-27.47,0-48.76-14.62-50.38-41.28h14.63 c1.63,15.93,11.38,28.28,35.76,28.28c20.15,0,27.3-9.26,27.3-19.67c0-15.92-8.62-18.85-34.62-24.87 c-17.39-4.06-38.19-10.08-38.19-32.66c0-18.37,14.14-30.56,39.82-30.56c24.7,0,41.93,12.68,43.88,36.73h-14.62 c-2.12-15.6-10.89-23.73-29.26-23.73c-16.41,0-25.19,6.34-25.19,15.93c0,15.44,12.52,17.55,29.58,21.78 C605.98,58.97,623.04,63.36,623.04,89.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.05,17.04h-38.68v-13h91.99v13h-38.68v103.2h-14.62V17.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M772.18,122.51c-31.04,0-44.53-17.22-44.53-40.95V4.04h14.63v77.52c0,18.85,9.75,27.95,29.9,27.95 c20.15,0,29.9-9.1,29.9-27.95V4.04h14.63v77.52C816.71,105.29,803.22,122.51,772.18,122.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M873.38,4.06h-42.1v12.97h42.1c29.57,0,37.04,22.45,37.04,45.2c0,22.75-7.47,45-37.04,45h-42.1v13.02h42.1 c32.03,0,51.68-20.63,51.68-58.02C925.06,24.84,905.41,4.06,873.38,4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M950.24,4.04v116.2h-14.63V4.04H950.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M963.3,62.06c0-34.94,22.75-60.3,56.88-60.3c34.13,0,56.88,25.36,56.88,60.3s-22.75,60.45-56.88,60.45 C986.05,122.51,963.3,97,963.3,62.06z M1062.44,62.06c0-25.03-13-47.3-42.26-47.3c-29.25,0-42.25,22.27-42.25,47.3 s13,47.45,42.25,47.45C1049.44,109.51,1062.44,87.09,1062.44,62.06z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogo);
export default __webpack_public_path__ + "static/media/navLogo.901f3c6e47481d1f8497e380f3ae8d9f.svg";
export { ForwardRef as ReactComponent };